import React from "react"

function ContactC() {
  return (
    <svg fill="none" viewBox="0 0 266 150">
      <path fill="var(--solid)" d="M0 0h266v150H0z" />
      <rect
        x={113}
        y={117}
        width={40}
        height={10}
        rx={2}
        fill="var(--main-500)"
      />
      <rect
        x={63}
        y={81}
        width={140}
        height={30}
        rx={2}
        fill="var(--base-400)"
      />
      <rect
        x={63}
        y={65}
        width={66}
        height={10}
        rx={2}
        fill="var(--base-400)"
      />
      <rect
        x={135}
        y={65}
        width={68}
        height={10}
        rx={2}
        fill="var(--base-400)"
      />
      <rect
        x={90}
        y={24}
        width={86}
        height={5}
        rx={2.5}
        fill="var(--solid-900)"
      />
      <rect
        x={80}
        y={33}
        width={106}
        height={4}
        rx={2}
        fill="var(--base-500)"
      />
      <rect x={85} y={41} width={97} height={4} rx={2} fill="var(--base-500)" />
    </svg>
  )
}

export default ContactC;
